import { HttpLink } from '@apollo/client';
import fetch from 'node-fetch';
import { hasValue } from '@famly/stat_ts-utils_has-value';
// There's a type mismatch between `@types/node-fetch` and `HttpLink.Options['fetch']`
// Since we're only using `node-fetch` for react-testing-library we'll just cast the type.
const typedFetch = fetch;
/**
 * Generates a query string suffix from the operation name.
 * This is used to improve developer experience by making GraphQL operations
 * visible in network requests.
 *
 * @param operation - The Apollo operation
 * @returns The operation name, optionally with an affix from context
 */
export const withOperationName = (operation) => {
    const { operationName } = operation;
    try {
        // Generic way for queries to add hints to the operation name
        const { affix } = operation.getContext();
        if (hasValue(affix)) {
            return `${operationName}_${affix}`;
        }
    }
    catch (_a) {
        return operationName;
    }
    return operationName;
};
/**
 * Creates an HTTP link for the given URL.
 *
 * If this is run in a test environment, then:
 * 1) The operation name of the GraphQL operation will be appended to the URL as query param
 * 2) A fetcher function is provided as this is needed for the react testing library
 *
 * @param url - The URL of the GraphQL endpoint
 * @returns An HttpLink with the said properties
 */
export const createHttpLink = (url) => {
    const isTestingEnvironment = process.env.TEST_TYPE === 'jest';
    return new HttpLink({
        uri: operation => {
            /**
             * This adds a NOOP query string to the graphql URL which solely consists of the
             * operation name. This is exclusively done to improve the development experience
             */
            return `${url}?${withOperationName(operation)}`;
        },
        // A fetcher function is required when React testing library tests are run, if the fetcher function is not found then that will result into a failing test.
        fetch: isTestingEnvironment ? typedFetch : undefined,
    });
};
